import api from '../../services/api';

// Lonnii Desktop data comes from the .NET licence server (/api/admin/desktop on www.lonnii.com),
// which checks the same dashboard login. No cookies are involved, so the browser's cross-site
// request goes without credentials - the .NET API does not accept them.
const options = { withCredentials: false, skipAuthRedirect: true };

const desktopApi = {
  overview: () => api.get('/api/admin/desktop/overview', options).then((r) => r.data),

  shops: ({ search = '', filter = 'all' } = {}) => {
    const params = new URLSearchParams();
    if (search.trim()) params.set('search', search.trim());
    if (filter !== 'all') params.set('filter', filter);
    const query = params.toString();
    return api.get(`/api/admin/desktop/shops${query ? `?${query}` : ''}`, options).then((r) => r.data);
  },

  shop: (id) => api.get(`/api/admin/desktop/shops/${encodeURIComponent(id)}`, options).then((r) => r.data),

  removeDevice: (shopId, deviceId, reason) =>
    api.delete(
      `/api/admin/desktop/shops/${encodeURIComponent(shopId)}/devices/${encodeURIComponent(deviceId)}` +
        (reason ? `?reason=${encodeURIComponent(reason)}` : ''),
      options
    ),

  setMaxDevices: (shopId, maxDevices) =>
    api.put(`/api/admin/desktop/shops/${encodeURIComponent(shopId)}/max-devices`, { maxDevices }, options)
      .then((r) => r.data),

  // The latest cloud backup as a plain SQLite file, saved through the browser.
  downloadDatabase: async (shopId, fileName) => {
    const response = await api.get(`/api/admin/desktop/shops/${encodeURIComponent(shopId)}/database`,
      { ...options, responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  },

  setBlocked: (shopId, blocked, reason) =>
    api.put(`/api/admin/desktop/shops/${encodeURIComponent(shopId)}/block`, { blocked, reason }, options),

  // Phone-only: our server hosts the shop, its computers are retired. Returns { retiredDevices }.
  setPhoneOnly: (shopId, phoneOnly) =>
    api.put(`/api/admin/desktop/shops/${encodeURIComponent(shopId)}/phone-only`, { phoneOnly }, options)
      .then((r) => r.data),
};

// An empty list and a failed request must not look the same.
export const describeError = (error) => {
  const status = error.response?.status;
  if (!error.response) return 'Serveur Lonnii Desktop injoignable. Vérifiez la connexion ou l\'état du serveur.';
  if (status === 401) return 'Le serveur Lonnii Desktop refuse votre session. Reconnectez-vous ; si cela persiste, sa clé du tableau de bord est à vérifier.';
  if (status === 404) return 'Introuvable (404). Le serveur Lonnii Desktop doit peut-être être mis à jour.';
  if (status === 403) {
    return error.response.data?.required
      ? `Permission requise : ${error.response.data.required}`
      : "Vous n'avez pas la permission de faire cela.";
  }
  return error.response.data?.error || `Erreur du serveur (${status})`;
};

export default desktopApi;
